module.exports = __webpack_public_path__ + "img/constant-contact.334cb82e.png";